import { Sociedad } from "../../../../../infraestructure/persistence/rest/SociedadesAdapter";

export const optionTodas = [{ label:'Todas las Sociedades', value: undefined}];

export const createOptions = (data:any,optionAll:any) =>{
  const todas = (optionAll === true) ? optionTodas : []
  return [...todas,...data.map((s: Sociedad)=> { return { label: s.sociedad, value: s.idSociedad, codPais: s.codPais } })]
}

export const createSocPorc = (data:any) =>{
  return data.map((s: any)=> { return {idSociedad:s.idSociedad, sociedad:s.sociedad, porcentaje: s.porcentaje.toString(), desarrollaIngenieria: s.desarrollaIngenieria} })
}